import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { PatientsModule } from './modules/patients.module';
import { AdmissionsModule } from './modules/admission.module';
import { DashboardModule } from './modules/dashboard.module';
import { PdqModule } from './modules/pdq.module';
import { AppComponent } from './app.component';
import { initializeApp } from './init-app';
import { KeycloakService } from 'keycloak-angular';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { MenuService } from './services/menu.service';
import { PatientService } from './services/patient.service';
import { UserService } from './services/user.service';
import { Store } from '@ngrx/store';
import { TenantSettingsService } from './services/tenantSettings.service';
import { AuthService } from './services/auth.service';
import { PermissionsInterceptor } from './interceptors/permissions.interceptor';
import { SwalToastService } from './services/swal.service';
import { AppointmentSignalService } from './services/appointmentSignalR.service';
import { SharedModule } from './modules/shared.module';
import { StandaloneModule } from './modules/standalone.module';
import { WorkspaceModule } from './modules/workspace.module';
import { AppointmentsModule } from './modules/appointments.module';
import { IpsModule } from './modules/ips.module';
import { UserManagementModule } from './modules/userManagement.module';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    SharedModule,
    StandaloneModule,
    PatientsModule,
    AppointmentsModule,
    WorkspaceModule,
    AdmissionsModule,
    DashboardModule,
    UserManagementModule,
    IpsModule,
    PdqModule,
  ],
  providers: [
    provideAppInitializer(() => {
      const initializerFn = initializeApp(
        inject(KeycloakService),
        inject(AuthService),
        inject(TenantSettingsService),
        inject(TranslateService),
        inject(PatientService),
        inject(MenuService),
        inject(Store),
        inject(SwalToastService),
        inject(AppointmentSignalService),
        inject(UserService)
      );
      return initializerFn();
    }),

    {
      provide: HTTP_INTERCEPTORS,
      useClass: PermissionsInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
